import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  Alert,
  IconButton
} from '@mui/material';
import SupportIcon from '@mui/icons-material/Support';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LogoutIcon from '@mui/icons-material/Logout';
import './SupportContact.css';

const SupportContact = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Remove token when component mounts
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Clear any other auth-related data
    sessionStorage.clear();
    
    // Update page title
    document.title = 'Account Setup Required - Contact Support';
  }, []);

  const handleLogout = () => {
    // Additional cleanup if needed
    navigate('/login');
  };

  const handleContactSupport = () => {
    // You can implement direct contact methods here
    // For now, we'll show the contact information
  };

  return (
    <div className="support-contact-container">
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper 
          elevation={3} 
          className="support-contact-paper"
          sx={{ 
            p: 4, 
            textAlign: 'center',
            borderRadius: 2
          }}
        >
          {/* Header */}
          <Box className="support-contact-header">
            <SupportIcon 
              className="support-contact-icon"
              sx={{ 
                fontSize: 64, 
                color: '#1344EB',
                mb: 2
              }} 
            />
            <Typography 
              variant="h4" 
              component="h1" 
              className="support-contact-title"
              sx={{ 
                fontWeight: 'bold',
                color: '#141218',
                mb: 1
              }}
            >
              Account Setup Required
            </Typography>
            <Typography 
              variant="body1" 
              className="support-contact-subtitle"
              sx={{ 
                color: '#666',
                fontSize: '16px'
              }}
            >
              Your account requires additional configuration. Please contact our support team.
            </Typography>
          </Box>

          {/* Alert Message */}
          <Alert 
            severity="info" 
            className="support-contact-alert"
            sx={{ 
              mb: 4,
              textAlign: 'left',
              '& .MuiAlert-message': {
                fontSize: '14px'
              }
            }}
          >
            <Typography variant="body2" sx={{ mb: 1 }}>
              <strong>Why am I seeing this page?</strong>
            </Typography>
            <Typography variant="body2">
              Your account has been created but requires parent account assignment. 
              This is a security measure to ensure proper account hierarchy and access control.
            </Typography>
          </Alert>

          {/* Contact Information */}
          <Box className="support-contact-section">
            <Typography 
              variant="h6" 
              className="support-contact-section-title"
              sx={{ 
                fontWeight: '600',
                color: '#141218',
                mb: 2
              }}
            >
              Contact Our Support Team
            </Typography>
            
            <Box className="support-contact-buttons">
              <Button
                variant="outlined"
                startIcon={<EmailIcon />}
                onClick={handleContactSupport}
                sx={{
                  borderColor: '#1344EB',
                  color: '#1344EB',
                  '&:hover': {
                    borderColor: '#0D47A1',
                    backgroundColor: 'rgba(19, 68, 235, 0.08)'
                  }
                }}
              >
                support@plutus21.com
              </Button>
              
              <Button
                variant="outlined"
                startIcon={<PhoneIcon />}
                onClick={handleContactSupport}
                sx={{
                  borderColor: '#1344EB',
                  color: '#1344EB',
                  '&:hover': {
                    borderColor: '#0D47A1',
                    backgroundColor: 'rgba(19, 68, 235, 0.08)'
                  }
                }}
              >
                +1 (555) 123-4567
              </Button>
            </Box>
          </Box>

        

          {/* Action Buttons */}
          <Box className="support-contact-actions">
            <Button
              variant="contained"
              startIcon={<SupportIcon />}
              onClick={handleContactSupport}
              sx={{
                backgroundColor: '#1344EB',
                '&:hover': {
                  backgroundColor: '#0D47A1'
                }
              }}
            >
              Contact Support
            </Button>
            
            <Button
              variant="outlined"
              startIcon={<LogoutIcon />}
              onClick={handleLogout}
              sx={{
                borderColor: '#666',
                color: '#666',
                '&:hover': {
                  borderColor: '#333',
                  backgroundColor: 'rgba(0, 0, 0, 0.08)'
                }
              }}
            >
              Return to Login
            </Button>
          </Box>
        </Paper>
      </Container>
    </div>
  );
};

export default SupportContact; 